import clsx from "clsx";
import { CalendarDays, SlidersHorizontal } from "lucide-react";

import type { Period } from "../../types.ts";

import styles from "./period-selector.module.css";

export interface PeriodSelectorProps {
  value: Period;
  onChange: (period: Period) => void;
  disabled?: boolean;
}

const ITEMS: { value: Period; label: string; icon: "calendar" | "sliders" }[] = [
  { value: "MONTHLY", label: "Monthly", icon: "calendar" },
  { value: "WEEKLY", label: "Weekly", icon: "calendar" },
  { value: "CUSTOM", label: "Custom", icon: "sliders" },
];

export function PeriodSelector({
  value,
  onChange,
  disabled = false,
}: PeriodSelectorProps) {
  return (
    <div className={styles.root} role="tablist" aria-label="Overview period">
      {ITEMS.map((item) => (
        <button
          key={item.value}
          type="button"
          role="tab"
          aria-selected={value === item.value}
          disabled={disabled}
          className={clsx(styles.tab, value === item.value && styles.tabActive)}
          onClick={() => onChange(item.value)}
        >
          {item.icon === "calendar" ? (
            <CalendarDays size={14} strokeWidth={2} aria-hidden />
          ) : (
            <SlidersHorizontal size={14} strokeWidth={2} aria-hidden />
          )}
          {item.label}
        </button>
      ))}
    </div>
  );
}
